import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#1E77DF',
        secondary: '#2196f3',
        accent: '#00BFA5',
        error: '#f44336',
        info: '#00bcd4',
        success: '#4CAF50',
        warning: '#FFC107',
      },
      dark: {
        primary: '#1E77DF',
        secondary: '#2196f3',
        accent: '#00BFA5',
        error: '#f44336',
        info: '#00bcd4',
        success: '#4CAF50',
        warning: '#FFC107',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});
